import { apiService } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export interface AdherenceStatistic {
  id: number;
  userId: number;
  weekStartDate: string;
  weekEndDate: string;
  totalDiaryItems: number;
  completedDiaryItems: number;
  adherencePercentage: number;
  createdAt: string;
  updatedAt: string;
}

export interface AdherenceFilters {
  start_date?: string;
  end_date?: string;
}

const getDateNWeeksAgo = (n: number): string => {
  const date = new Date();
  date.setDate(date.getDate() - n * 7);
  return date.toISOString().split('T')[0];
};

const getCurrentDate = (): string => {
  return new Date().toISOString().split('T')[0];
};

export const adherenceService = {
  getAdherenceStatistics: async (
    userId: string | number,
    filters?: AdherenceFilters
  ): Promise<AdherenceStatistic[]> => {
    const params = new URLSearchParams();

    const startDate = filters?.start_date ?? getDateNWeeksAgo(10);
    const endDate = filters?.end_date ?? getCurrentDate();
    params.append('start_date', startDate);
    params.append('end_date', endDate);

    const url = `${API_BASE_URL}/clinic/patient/${userId}/adherence-statistics/?${params.toString()}`;
    return await apiService.get(url);
  },

  getLastTenWeeksAdherence: async (userId: string | number): Promise<AdherenceStatistic[]> => {
    return adherenceService.getAdherenceStatistics(userId, {
      start_date: getDateNWeeksAgo(10),
      end_date: getCurrentDate()
    });
  },

  getYearAdherence: async (userId: string | number): Promise<AdherenceStatistic[]> => {
    return adherenceService.getAdherenceStatistics(userId, {
      start_date: getDateNWeeksAgo(52),
      end_date: getCurrentDate()
    });
  }
};
